export default __webpack_public_path__ + "preview-clone-meeting.9d9f4de8.svg";